import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BelenderRoutes } from 'src/app/belender/interfaces/belender-route.interface';
import { TermsComponent } from './terms.component';
import { QuicklinkModule } from 'ngx-quicklink';

const routes: BelenderRoutes = [
  {
    path: ':flow',
    component: TermsComponent
  },
  {
    path: ':flow/:idUser',
    component: TermsComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule, QuicklinkModule]
})
export class TermsRoutingModule {
}
